import { render } from "./MessageModalBooking.vue?vue&type=template&id=27806272&scoped=true"
import script from "./MessageModalBooking.vue?vue&type=script&lang=js"
export * from "./MessageModalBooking.vue?vue&type=script&lang=js"

import "./MessageModalBooking.vue?vue&type=style&index=0&id=27806272&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27806272"]])

export default __exports__